import { useState } from 'react';

import {
  ArrowDropDown,
  ArrowDropUp,
  ClipboardText,
  VFlex,
  VStack,
} from '@/package';
import { useTaskFrameStore, useToolPermissionStore } from '@/store';

const ToolDevTool = () => {
  const {
    currentFrame,
    enabledSubmit,
    frameCount,
    isNotFoundedFrame,
    isUpsertLabelingPending,
    allFrameList,
    nextFrame,
    nextReview,

    prevFrame,
    prevReview,
    reviewComment,
    reviewData,
    selectedTask,
    selectedTaskId,
  } = useTaskFrameStore();
  const { permission } = useToolPermissionStore();
  const state = {
    currentFrame,
    enabledSubmit,
    frameCount,
    isNotFoundedFrame,
    isUpsertLabelingPending,
    allFrameList,
    nextFrame,
    nextReview,
    permission,
    prevFrame,
    prevReview,
    reviewComment,
    reviewData,
    selectedTask,
    selectedTaskId,
  };
  const [visible, setVisible] = useState(false);

  return !import.meta.env.DEV ? (
    <></>
  ) : (
    <VStack
      className="fixed top-1 right-1 z-[1000] max-h-[1280px] overflow-y-auto rounded-md bg-black/90 text-body-lg text-white"
      gap={0.5}
    >
      <VFlex className="sticky top-0" justify="end">
        <div role="button" onClick={() => setVisible(v => !v)}>
          {visible ? <ArrowDropDown /> : <ArrowDropUp />}
        </div>
      </VFlex>

      {visible &&
        Object.entries(state).map(([k, v]) => {
          return (
            <VFlex className="px-4 py-2" key={k} items="start">
              <div className="w-50">{k}</div>
              <div className="relative w-[300px] overflow-hidden rounded-md bg-gray-600 px-2 py-1 text-body-sm">
                <div
                  role="button"
                  className="absolute top-1 right-2 hover:text-skyBlue-200"
                  onClick={() => {
                    navigator.clipboard.writeText(JSON.stringify(v, null, 2));
                  }}
                >
                  <ClipboardText className="size-3.5" />
                </div>
                <div className="max-h-[240px] overflow-y-auto whitespace-pre">
                  {JSON.stringify(v, null, 2)}
                </div>
              </div>
            </VFlex>
          );
        })}
    </VStack>
  );
};

export default ToolDevTool;
